import { MovieStarOutlineIcon } from './MovieStarOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 31542EFD-68FE-435F-8B00-1BDFB218D9E2
 * name movie-star-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-star-outline.svg
 * tags
 * - Video / Movie 
 */
export const MovieFavoriteOutlineIcon = MovieStarOutlineIcon;
export default MovieFavoriteOutlineIcon